module.exports = __webpack_public_path__ + "img/minus.8444e321.svg";